import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EGeoActionType {
  SetRegionId = 'geo/set-region-id',
}

export type TSetRegionId = ITypedReduxAction<EGeoActionType.SetRegionId, number>;

export type TGeoActions = TSetRegionId;
